import { Modal, ModalHeader, ModalBody } from "reactstrap";

export default function ModalOrientationFirebase(props) {
  const { isOpen, toggle } = props;

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
        <ModalHeader toggle={toggle}>Orientações Firebase</ModalHeader>
        <ModalBody>
          <ol className="ps-3">
            <li>
              Acessar{" "}
              <a
                href="https://console.firebase.google.com/"
                target="_blank"
                rel="noreferrer"
              >
                Firebase
              </a>
            </li>
            <li className="mt-2">Selecionar projeto</li>
            <li className="mt-2">Selecionar a opção Adicionar app</li>
            <li className="mt-2">
              Em registrar APP inserir Bundle e nome do APP
            </li>
          </ol>
        </ModalBody>
      </Modal>
    </>
  );
}
